import warning, { resetWarned } from "rc-util/es/warning";
export { resetWarned };
export default (function (valid, component, message) {
  warning(valid, "[antd: ".concat(component, "] ").concat(message));
});


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/_util/warning.js
// module id = 14
// module chunks = 0